import React from 'react'
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import {
  mdiMenu,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiViewGridPlusOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiTools,
} from '@mdi/js'

/**
 * Barra superior del shell Studio (solo cromo).
 */
function StudioTopBar({
  title,
  subtitle,
  planLabel,
  loadIndicator,
  isFullscreen,
  onToggleMenu,
  onToggleFullscreen,
  onLayout,
  onToggleLeftRail,
  leftRailCollapsed,
  onToggleRightRail,
  rightRailCollapsed,
  hideRightRailToggle = false,
  bell,
  installBanner,
  showMenu = true,
}) {
  const iconColor = 'var(--udv-icon, #d8d0c0)'
  const accentColor = 'var(--udv-accent, #c4a574)'

  return (
    <header className="udv-studio-topbar">
      <div className="udv-studio-topbar-left">
        {showMenu && (
          <Tooltip title="Menú">
            <IconButton
              size="small"
              onClick={onToggleMenu}
              className="udv-studio-topbar-btn"
              aria-label="Menú"
            >
              <Icon path={mdiMenu} size={0.88} color={iconColor} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={leftRailCollapsed ? 'Mostrar series' : 'Ocultar series'}>
          <IconButton
            size="small"
            onClick={onToggleLeftRail}
            className="udv-studio-topbar-btn"
            aria-label="Panel series"
          >
            <Icon
              path={leftRailCollapsed ? mdiChevronRight : mdiChevronLeft}
              size={0.88}
              color={accentColor}
            />
          </IconButton>
        </Tooltip>
        <div className="udv-studio-topbar-brand">
          <span className="udv-studio-topbar-brand-mark">UDV</span>
          {planLabel ? (
            <span className="udv-studio-topbar-brand-mode">{planLabel}</span>
          ) : null}
        </div>
      </div>

      <div className="udv-studio-topbar-center">
        <div className="udv-studio-topbar-title">{title || 'Sin estudio'}</div>
        {subtitle ? (
          <div className="udv-studio-topbar-sub">{subtitle}</div>
        ) : null}
        {loadIndicator}
      </div>

      <div className="udv-studio-topbar-right">
        {installBanner}
        {bell}
        <Tooltip title="Layout">
          <IconButton
            size="small"
            onClick={onLayout}
            className="udv-studio-topbar-btn"
            aria-label="Layout"
          >
            <Icon path={mdiViewGridPlusOutline} size={0.88} color={iconColor} />
          </IconButton>
        </Tooltip>
        <Tooltip title={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}>
          <IconButton
            size="small"
            onClick={onToggleFullscreen}
            className="udv-studio-topbar-btn"
            aria-label="Fullscreen"
          >
            <Icon
              path={isFullscreen ? mdiFullscreenExit : mdiFullscreen}
              size={0.88}
              color={iconColor}
            />
          </IconButton>
        </Tooltip>
        {!hideRightRailToggle && onToggleRightRail ? (
          <Tooltip title={rightRailCollapsed ? 'Mostrar herramientas' : 'Ocultar herramientas'}>
            <IconButton
              size="small"
              onClick={onToggleRightRail}
              className="udv-studio-topbar-btn"
              aria-label="Panel herramientas"
            >
              <Icon
                path={rightRailCollapsed ? mdiTools : mdiChevronRight}
                size={0.88}
                color={accentColor}
              />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
    </header>
  )
}

export default StudioTopBar
